import { FIELD_TYPES } from "../../../widgets/fields";

export const PopUpFormElements = {
    docType: {
        name: "docType",
        placeholder: "Enter Doc Type",
        label: "Doc Type",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    submissionDate: {
        name: "submissionDate",
        placeholder: "Enter Submission Date",
        label: "Submission Date",
        type: FIELD_TYPES.DATE_TIME_PICKER,
        isMandatory: true
    },
    submittedTo: {
        name: "submittedTo",
        placeholder: "Enter Submitted To",
        label: "Submitted To",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    remarks: {
        name: "remarks",
        placeholder: "Enter Remarks",
        label: "Remarks",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    submissionType: {
		name: "submissionType",
		placeholder: "Submission Type",
		label: "Submission Type",
		type: FIELD_TYPES.DROP_DOWN,
		isMandatory: true,
		values: [{ label: 'Journal Article', value: 'Journal Article' },
		{ label: 'Book', value: 'Book' },
		{ label: 'Book Section', value: 'Book Section' },
		{ label: 'Blog Post', value: 'Blog Post' },
		{ label: 'Conference Paper', value: 'Conference Paper' },
		{ label: 'Funding Proposal', value: 'Funding Proposal' },
		{ label: 'Pre Print', value: 'Pre Print' },
		{ label: 'Poster', value: 'Poster' },
		{ label: 'Thesis', value: 'Thesis' },
		{ label: 'Code', value: 'Code' },
		{ label: 'Cover Page', value: 'Cover Page' },
		{ label: 'Data', value: 'Data' },
		{ label: 'Experiment Findings', value: 'Experiment Findings' },
		{ label: 'Method', value: 'Method' },
		{ label: 'Negative Result', value: 'Negative Result' },
		{ label: 'Patent', value: 'Patent' },
		{ label: 'Raw Data', value: 'Raw Data' },
		{ label: 'Technical Report', value: 'Technical Report' }
		]
	},
}